import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAcademicYear as apiRestore } from "../../api/apiAcademicYears";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreAcademicYear() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreAcademicYear, isPending: isRestore } = useMutation({
        mutationFn: (id) => apiRestore(id),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicYears"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreAcademicYear, isRestore };
}
